import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTrackingComponent } from './document-tracking/document-tracking.component';
import { DocumentRequirementsComponent } from './document-requirements/document-requirements.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { DocumentTrackingRoutingModule } from './document-tracking-routing.module';
import { MatInputModule } from '@angular/material/input';
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DocumentVersionsComponent } from './document-tracking/document-versions/document-versions.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DocumentNotesComponent } from './document-tracking/document-notes/document-notes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AddVersionModalComponent } from './document-tracking/document-versions/add-version-modal/add-version-modal.component';
import { AddDocumentDialogComponent } from './document-tracking/add-document-dialog/add-document-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { InitializeTrackerDialogComponent } from './document-requirements/initialize-tracker-dialog/initialize-tracker-dialog.component';
import { AddDocumentComponent } from './document-requirements/add-document/add-document.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PermissionPipe } from '../pipes/permission.pipe';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    DocumentTrackingComponent,
    DocumentRequirementsComponent,
    DocumentVersionsComponent,
    DocumentNotesComponent,
    AddVersionModalComponent,
    AddDocumentDialogComponent,
    InitializeTrackerDialogComponent,
    AddDocumentComponent,
  ],
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatTableModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    DocumentTrackingRoutingModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    PipesModule,
  ],
})
export class DocumentTrackingModule {}
